import React, { useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";

const PrivacyPolicy = () => {
	const [activeIndex, setActiveIndex] = useState(null);

	const handleToggle = (index) => {
		setActiveIndex(activeIndex === index ? null : index);
	};

	const accordionData = [
		{
			title: "Your Health, Your Schedule Book Now ?",
			content:
				"Donec egestas odio id viverra dapibus. Curabitur quam massa, facilisis at ipsum eget, consequat lobortis dui. Nam gravida urna id nibh rhoncus efficitur. Suspendisse vehicula, nisl sed congue tincidunt, nisl velit tempor magna, sit amet facilisis mauris ante a felis. Morbi pharetra diam in lectus faucibus efficitur. Donec viverra ipsum eu lectus posuere, sit amet accumsan nisl porttitor. Nulla fringilla.",
		},
		{
			title: "Lorem ipsum dolor sit amet, consecte adipiscing elit ?",
			content:
				"Donec egestas odio id viverra dapibus. Curabitur quam massa, facilisis at ipsum eget, consequat lobortis dui. Nam gravida urna id nibh rhoncus efficitur. Suspendisse vehicula, nisl sed congue tincidunt, nisl velit tempor magna, sit amet facilisis mauris ante a felis. Morbi pharetra diam in lectus faucibus efficitur. Donec viverra ipsum eu lectus posuere, sit amet accumsan nisl porttitor. Nulla fringilla.",
		},
		{
			title:
				"Vivamus pulvinar quis velit at tempus. Nam pretium sed nisi id aliquet ?",
			content:
				"Donec egestas odio id viverra dapibus. Curabitur quam massa, facilisis at ipsum eget, consequat lobortis dui. Nam gravida urna id nibh rhoncus efficitur. Suspendisse vehicula, nisl sed congue tincidunt, nisl velit tempor magna, sit amet facilisis mauris ante a felis. Morbi pharetra diam in lectus faucibus efficitur. Donec viverra ipsum eu lectus posuere, sit amet accumsan nisl porttitor. Nulla fringilla.",
		},
		{
			title:
				"Etiam consectetur sed arcu quis dignissim. Aenean suscipit ipsum fringilla metus ?",
			content:
				"Donec egestas odio id viverra dapibus. Curabitur quam massa, facilisis at ipsum eget, consequat lobortis dui. Nam gravida urna id nibh rhoncus efficitur. Suspendisse vehicula, nisl sed congue tincidunt, nisl velit tempor magna, sit amet facilisis mauris ante a felis. Morbi pharetra diam in lectus faucibus efficitur. Donec viverra ipsum eu lectus posuere, sit amet accumsan nisl porttitor. Nulla fringilla.",
		},
		{
			title: "Donec egestas odio id viverra dapibus. Curabitur quam massa ?",
			content:
				"Donec egestas odio id viverra dapibus. Curabitur quam massa, facilisis at ipsum eget, consequat lobortis dui. Nam gravida urna id nibh rhoncus efficitur. Suspendisse vehicula, nisl sed congue tincidunt, nisl velit tempor magna, sit amet facilisis mauris ante a felis. Morbi pharetra diam in lectus faucibus efficitur. Donec viverra ipsum eu lectus posuere, sit amet accumsan nisl porttitor. Nulla fringilla.",
		},
		{
			title:
				"Suspendisse vehicula, nisl sed congue tincidunt, nisl velit tempor magna ?",
			content:
				"Donec egestas odio id viverra dapibus. Curabitur quam massa, facilisis at ipsum eget, consequat lobortis dui. Nam gravida urna id nibh rhoncus efficitur. Suspendisse vehicula, nisl sed congue tincidunt, nisl velit tempor magna, sit amet facilisis mauris ante a felis. Morbi pharetra diam in lectus faucibus efficitur. Donec viverra ipsum eu lectus posuere, sit amet accumsan nisl porttitor. Nulla fringilla.",
		},
		// Add more accordion items here if needed
	];
	return (
		<>
			<Header />
			<PageHeader pagename="FAQs" />
			<section className="services-pages pt-5 pb-5">
				<div className="container">
					<div className="row">
						<div className="col-lg-10 mx-auto">
							<div className="accordion">
								{accordionData.map((item, index) => (
									<div
										key={index}
										className={`accordion-item mt-3 ${
											activeIndex === index ? "active" : ""
										}`}
										onClick={() => handleToggle(index)}
									>
										<h4 className="accordion-heading">
											{item.title}
											<div className="edit-btn ">
												<div className="edit-btn">
													<i
														className={`fas ${
															activeIndex === index ? "fa-minus" : "fa-plus"
														} accordion-icon nav-anchor`}
													></i>
												</div>
											</div>
										</h4>
										{activeIndex === index && (
											<div className="accordion-content">
												<p>{item.content}</p>
											</div>
										)}
									</div>
								))}
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-12 text-center mt-4">
							<a
								href="signin"
								class="btn log-in level-7 primary-regular-font text-decoration-none"
							>
								<span class="bg-wrapper">Load more</span>
							</a>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default PrivacyPolicy;
